(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-content.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-content.js');

'use strict';

const Loader = svs.components.ReactLoader.Loader;
const _svs$components$marke = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates,
  UPCOMING = _svs$components$marke.UPCOMING,
  FINISHED = _svs$components$marke.FINISHED,
  REG_OPEN_DRAW_DEFINED = _svs$components$marke.REG_OPEN_DRAW_DEFINED,
  REG_CLOSED_DRAW_DEFINED = _svs$components$marke.REG_CLOSED_DRAW_DEFINED,
  REG_OPEN_DRAW_OPEN = _svs$components$marke.REG_OPEN_DRAW_OPEN,
  REG_CLOSED_DRAW_OPEN = _svs$components$marke.REG_CLOSED_DRAW_OPEN,
  REG_OPEN_DRAW_LIVE = _svs$components$marke.REG_OPEN_DRAW_LIVE,
  REG_CLOSED_DRAW_LIVE = _svs$components$marke.REG_CLOSED_DRAW_LIVE,
  REG_OPEN_DRAW_FINALIZED = _svs$components$marke.REG_OPEN_DRAW_FINALIZED,
  REG_CLOSED_DRAW_FINALIZED = _svs$components$marke.REG_CLOSED_DRAW_FINALIZED,
  NO_COMPETITION = _svs$components$marke.NO_COMPETITION;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.content,
  CompetitionClosedDrawDefined = _svs$components$marke2.CompetitionClosedDrawDefined,
  CompetitionClosedDrawFinalized = _svs$components$marke2.CompetitionClosedDrawFinalized,
  CompetitionClosedDrawLive = _svs$components$marke2.CompetitionClosedDrawLive,
  CompetitionClosedDrawOpen = _svs$components$marke2.CompetitionClosedDrawOpen,
  CompetitionFinished = _svs$components$marke2.CompetitionFinished,
  CompetitionOpenDrawDefined = _svs$components$marke2.CompetitionOpenDrawDefined,
  CompetitionOpenDrawFinalized = _svs$components$marke2.CompetitionOpenDrawFinalized,
  CompetitionOpenDrawLive = _svs$components$marke2.CompetitionOpenDrawLive,
  CompetitionOpenDrawOpen = _svs$components$marke2.CompetitionOpenDrawOpen,
  CompetitionUpcoming = _svs$components$marke2.CompetitionUpcoming,
  NoCompetition = _svs$components$marke2.NoCompetition;
const useContent = competitionState => {
  switch (competitionState) {
    case UPCOMING:
      return CompetitionUpcoming;
    case REG_OPEN_DRAW_DEFINED:
      return CompetitionOpenDrawDefined;
    case REG_OPEN_DRAW_OPEN:
      return CompetitionOpenDrawOpen;
    case REG_OPEN_DRAW_LIVE:
      return CompetitionOpenDrawLive;
    case REG_OPEN_DRAW_FINALIZED:
      return CompetitionOpenDrawFinalized;
    case REG_CLOSED_DRAW_DEFINED:
      return CompetitionClosedDrawDefined;
    case REG_CLOSED_DRAW_OPEN:
      return CompetitionClosedDrawOpen;
    case REG_CLOSED_DRAW_LIVE:
      return CompetitionClosedDrawLive;
    case REG_CLOSED_DRAW_FINALIZED:
      return CompetitionClosedDrawFinalized;
    case FINISHED:
      return CompetitionFinished;
    case NO_COMPETITION:
      return NoCompetition;
    default:
      return Loader;
  }
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useContent', useContent);

 })(window);